import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../_guards/index';

import { DebtsComponent } from './debts.component';
import { ImportComponent } from './import.component';
import { ReceivableComponent } from './receivable.component';
import { VehicleComponent } from './vehicle.component';
import { VehiclesComponent } from './vehicles.component';
import { ViewdebtComponent } from './viewdebt.component';
import { ViewvehicleComponent } from './viewvehicle.component';

import { EditblondalComponent } from './editblondal.component';

import { EditComponent } from './edit.component';

import { UploadcollectionComponent } from './uploadcollection.component';

import { CollectionComponent } from './collection.component';
import { CollectedComponent } from './collected.component';
const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Debts'
    }, 
    canActivate: [AuthGuard], 
    children: [ 
      {
        path: 'editblondal/:id',
        component: EditblondalComponent,
        data: {
          title: 'Edit'
        }
      },
      {
        path: 'edit/:id',
        component: EditComponent,
        data: {
          title: 'Edit'
        }
      },
      {
        path: 'collected/:id',
        component: CollectedComponent,
        data: {
          title: 'Collection'
        }
      },
      {
        path: 'collection',
        component: CollectionComponent,
        data: {
          title: 'Collection'
        }
      },
      {
        path: 'uploadcollection',
        component: UploadcollectionComponent,
        data: {
          title: 'Upload Collection'
        }
      },
      {
        path: 'debts/:id',
        component: DebtsComponent,
        data: {
          title: 'Debts'
        }
      },
      {
        path: 'import',
        component: ImportComponent,
        data: {
          title: 'Import Debts'
        }
      },
      {
        path: 'receivable',
        component: ReceivableComponent,
        data: {
          title: 'Receivable Portfolio'
        }
      },
      {
        path: 'vehicle/:id',
        component: VehicleComponent,
        data: {
          title: 'Vehicle'
        }
      },
      {
        path: 'vehicles',
        component: VehiclesComponent,
        data: {
          title: 'Vehicles'
        }
      },
      {
        path: 'viewdebt/:id',
        component: ViewdebtComponent,
        data: {
          title: 'Debt Informations'
        }
      },
      {
        path: 'viewvehicle/:id',
        component: ViewvehicleComponent,
        data: {
          title: 'Debt Informations'
        }
      }
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DebtsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/debts/debts-routing.module.ts